import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_auth/_coach/orgs/$slug/athletes/$athleteId/",
)({
  loader({ params }) {
    throw redirect({ to: "/orgs/$slug/athletes/$athleteId/profile", params });
  },
});
